export type Rule<T> = (v: T) => boolean;

export function 非空Rule(v: string | unknown[] | null) {
    if (!v) return false;
    return v.length > 0;
}

export function 手机号Rule(v: string | null) {
    if (!v) return true;
    return /^1\d{10}$/.test(v);
}

export function 最大宽度限制Rule(max: number) {
    const 匹配数量 = (regExp: RegExp, target: string) => {
        if (target === null) return 0;
        const matches = regExp[Symbol.match](target);
        return matches !== null ? matches.length : 0;
    };

    return (v: string | null) => {
        if (v === null) return true;
        const 单字节数量 = 匹配数量(/[\x20-\xff]/g, v);
        const 双字节数量 = 匹配数量(/[^\x20-\xff]/g, v);
        return 单字节数量 + 双字节数量 * 2 <= max;
    };
}

export function 最小长度限制Rule(min: number) {
    return (v: string | unknown[] | null) => {
        if (!v) return true;
        return v.length >= min;
    };
}

export function 最大长度限制Rule(max: number) {
    return (v: string | unknown[] | null) => {
        if (!v) return true;
        return v.length <= max;
    };
}

export function 中文姓名Rule(v: string | null) {
    if (!v) return true;
    return /^[\u4e00-\u9fa5\u00b7\u002e]*$/.test(v);
}

export function UrlRule(v: string | null) {
    if (!v) return true;
    return HttpsUrlRule(v) || HttpUrlRule(v);
}

export function HttpUrlRule(v: string | null) {
    if (!v) return true;
    return /^((http)?:\/\/).+/.test(v);
}

export function HttpsUrlRule(v: string | null) {
    if (!v) return true;
    return /^((https)?:\/\/).+/.test(v);
}

export function 身份证Rule(v: string | null) {
    return (
        isDLIDCard(v) ||
        isXgIDCard(v) ||
        isAmIDCard(v) ||
        isTwIDCard(v) ||
        isTwDlIDCard(v) ||
        isXgDlIDCard(v) ||
        isAmDlIDCard(v)
    );
}

export function 包含允许的特殊字符Rule(v: string | null) {
    if (!v) return true;
    return /(?=.*[\x21-\x2f\x3A-\x40\x5B-\x60\x7B-\x7E])/.test(v);
}
export function 包含数字Rule(v: string | null) {
    if (!v) return true;
    return /(?=.*[0-9])/.test(v);
}
export function 包含大写Rule(v: string | null) {
    if (!v) return true;
    return /(?=.*[A-Z])/.test(v);
}
export function 正整数Rule(v: string | null) {
    if (!v) return true;
    return /(\d+)/.test(v);
}
export function 包含小写Rule(v: string | null) {
    if (!v) return true;
    return /(?=.*[a-z])/.test(v);
}

export function 密码合法Rule(v: string | null) {
    if (!v) return true;
    return !/(?=.*[^\x21-\x7e])/.test(v);
}
export function 密码中级强度要求Rule(v: string | null) {
    if (!v) return true;
    const 密码强度要求表 = [包含允许的特殊字符Rule, 包含数字Rule, 包含大写Rule, 包含小写Rule];
    return 密码强度要求表.filter((x) => x(v)).length >= 3;
}
function isDLIDCard(v: any) {
    console.log(v);
    if (!v) return true;
    if (v.length !== 18) return false;
    const city: { [index: string]: string } = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 ',
    };
    let pass = true;

    if (!v || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(v)) {
        //身份证号格式错误;
        pass = false;
    } else if (!city[v.substr(0, 2)]) {
        //地址编码错误;
        pass = false;
    } else {
        //校验位检查
        const values = v.split('');
        //∑(ai×Wi)(mod 11)
        //加权因子
        const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        //校验位
        const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
        let sum = 0;
        let ai = 0;
        let wi = 0;
        for (let i = 0; i < 17; i++) {
            ai = Number.parseInt(values[i]);
            wi = factor[i];
            sum += ai * wi;
        }
        if (parity[sum % 11] != values[17]) {
            //校验位错误;
            pass = false;
        }
    }
    console.log(pass);
    return pass;
}
// 港澳台身份证号码格式验证
// 香港身份证校验
function isXgIDCard(str: any) {
    var checkIDCard = /^[A-Z]\d{6}\([\dA]\)$/;
    console.log(checkIDCard.test(str));
    if (checkIDCard.test(str)) {
        var hash = (str.substring(0, 1).toUpperCase().charCodeAt() - 64) * 8;
        for (var i = 1; i <= 6; i++) {
            hash += parseInt(str.substring(i, i + 1)) * (8 - i);
        }
        console.log(hash);
        var validateNo = hash % 11;
        var ret: any = '';
        if (validateNo == 1) {
            ret = 'A';
        } else {
            ret = 11 - validateNo;
        }
        //                 console.log(ret);
        if (str.substring(8, 9) == ret) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}
// 澳门身份证校验
function isAmIDCard(str: any) {
    var checkIDCard = /^[1|5|7]\d{6}[(\d)]{3}$/;
    console.log(checkIDCard.test(str));
    if (checkIDCard.test(str)) {
        return true;
    } else {
        return false;
    }
}
// 台湾身份证验证
function isTwIDCard(idcard: any) {
    var checkIDCard = /^[A-Z][1-2]\d{8}$/;
    console.log(checkIDCard.test(idcard));
    if (checkIDCard.test(idcard)) {
        var area: any = {
            A: 10,
            B: 11,
            C: 12,
            D: 13,
            E: 14,
            F: 15,
            G: 16,
            H: 17,
            J: 18,
            K: 19,
            L: 20,
            M: 21,
            N: 22,
            P: 23,
            Q: 24,
            R: 25,
            S: 26,
            T: 27,
            U: 28,
            V: 29,
            X: 30,
            Y: 31,
            W: 32,
            Z: 33,
            I: 34,
            O: 35,
        };
        var idcard_array: any = new Array();
        idcard_array = idcard.split('');

        var jym =
            parseInt((area[idcard_array[0]] / 10).toString()) +
            9 * (area[idcard_array[0]] % 10) +
            8 * idcard_array[1] +
            7 * idcard_array[2] +
            6 * idcard_array[3] +
            5 * idcard_array[4] +
            4 * idcard_array[5] +
            3 * idcard_array[6] +
            2 * idcard_array[7] +
            1 * idcard_array[8];

        jym = (10 - (jym % 10)) % 10;

        if (idcard_array[9] == jym) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

/**
 * 从身份证号码中提取性别
 * 大陆身份证：第17位奇数为男，偶数为女
 * 台湾身份证：第2位1为男，2为女
 * 港澳身份证：无法提取，返回null
 * 港澳台居住证：同大陆身份证规则
 */
export function 从身份证获取性别(v: string | null): string | null {
    if (!v) return null;
    if (isDLIDCard(v) || isXgDlIDCard(v) || isAmDlIDCard(v) || isTwDlIDCard(v)) {
        const genderDigit = parseInt(v.charAt(16));
        return genderDigit % 2 === 1 ? '男' : '女';
    }
    if (isTwIDCard(v)) {
        const genderDigit = parseInt(v.charAt(1));
        return genderDigit === 1 ? '男' : '女';
    }
    return null;
}

/**
 * 从身份证号码中提取出生日期
 * 大陆身份证：第7-14位为YYYYMMDD
 * 港澳台居住证：同大陆身份证规则
 * 台湾身份证：无法提取出生日期
 * 港澳身份证：无法提取出生日期
 */
export function 从身份证获取出生日期(v: string | null): Date | null {
    if (!v) return null;
    if (isDLIDCard(v) || isXgDlIDCard(v) || isAmDlIDCard(v) || isTwDlIDCard(v)) {
        const year = parseInt(v.substring(6, 10));
        const month = parseInt(v.substring(10, 12)) - 1;
        const day = parseInt(v.substring(12, 14));
        const date = new Date(year, month, day);
        if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day) {
            return date;
        }
    }
    return null;
}

/**
 * 解析年龄限制字符串
 * 格式：1980-01-01~2000-01-01 代表限1980年1月1日至2000年1月1日出生内可报
 *       1980-01-01~ 代表1980年1月1日以后出生可报
 *       ~2000-01-01 代表2000年1月1日前出生可报
 * 注意：包括起始日期，不包括结束日期
 */
export function 解析年龄限制(v: string | null): { 最小出生日期: Date | null; 最大出生日期: Date | null } | null {
    if (!v || !v.includes('~')) return null;
    const parts = v.split('~');
    const parseLocalDate = (s: string) => {
        const [y, m, d] = s.split('-').map(Number);
        return new Date(y, m - 1, d);
    };
    const 最小出生日期 = parts[0] ? parseLocalDate(parts[0]) : null;
    const 最大出生日期 = parts[1] ? parseLocalDate(parts[1]) : null;
    return { 最小出生日期, 最大出生日期 };
}

function isXgDlIDCard(idcard: any) {
    const pattern = /^810000\d{12}$/;
    return pattern.test(idcard);
}

function isAmDlIDCard(idcard: any) {
    const pattern = /^820000\d{12}$/;
    return pattern.test(idcard);
}

function isTwDlIDCard(idcard: any) {
    const pattern = /^830000\d{11}[\dX]$/;
    return pattern.test(idcard);
}
